<div class="container-fluid add-comments pb-3">
    <form #reviewCommentForm="ngForm">
        <div class="row col-12 p-0">
            <h5>{{isUserHasReviewerPermission ? 'Add' : 'View'}} comments / notes for each document</h5>
        </div>
        <div class="row" class="review-accordion">
            <span class="pl-2" *ngIf="listDocuments.length <= 0">No comments</span>
            <div class="col-md-12" *ngIf="listDocuments.length > 0">
                <p-accordion [multiple]="true" collapseIcon="pi pi-fw pi-chevron-up"
                    expandIcon="pi pi-fw pi-chevron-down" class="review-accordions">
                    <p-accordionTab header="All Documents List">
                        <ng-template pTemplate="content">
                            <div *ngFor="let item of listDocuments; let itemIndex= index;">
                                <p-accordionTab [header]="item.titleSheetName" class="pt-2 pb-2">
                                    <ng-template pTemplate="content" [ngModelGroup]="itemIndex">
                                        <h6 class="pt-3">
                                            {{isUserHasReviewerPermission ? 'Enter your review' : 'Review'}} for
                                            following sections under {{item.titleSheetName}}
                                        </h6>
                                        <div *ngFor="let subItem of item.docs; let subItemIndex= index;">
                                            <p-accordionTab [header]="subItem.docName">
                                                <ng-template pTemplate="content" [ngModelGroup]="subItemIndex">
                                                    <h6>{{isUserHasReviewerPermission ? 'Enter your' : 'Reviewer'}}
                                                        comments for {{subItem.docName}} </h6>
                                                    <div class="row col-md-12 p-2">
                                                        <div class="row col-md-12 input-disabled">
                                                            <textarea name="comments" type="text" rows="3" class="w-100"
                                                                placeholder="Enter Comments"
                                                                [disabled]="!isUserHasReviewerPermission || disabledControls"
                                                                [(ngModel)]="subItem.comments" name="comments"
                                                                #comments="ngModel"></textarea>
                                                        </div>
                                                        <div class="row col-md-12" *ngIf="isUserHasReviewerPermission">
                                                            <button pButton type="button" label="Save" icon="pi pi-save"
                                                                (click)="handleSave(subItem, item)"
                                                                [ngClass]="reviewCommentForm.invalid  || disabledControls ? 'btn-success button-width-icon-left mr-3 btn-success_disabled':'btn-success button-width-icon-left mr-3'"
                                                                [disabled]="reviewCommentForm.invalid  || disabledControls"></button>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </p-accordionTab>
                                        </div>
                                        <div class="col-md-12 row pt-2 pb-2">
                                            <h6>Review Comments for {{item.titleSheetName}} section</h6>
                                            <div class="row col-md-12 input-disabled">
                                                <textarea name="comments" type="text" rows="3" class="w-100"
                                                    placeholder="Enter Comments" [(ngModel)]="item.comments"
                                                    [disabled]="!isUserHasReviewerPermission || disabledControls"
                                                    name="comments" #comments="ngModel"></textarea>
                                            </div>
                                            <div class="row col-md-12" *ngIf="isUserHasReviewerPermission">
                                                <button pButton type="button" label="Save" icon="pi pi-save"
                                                    (click)="handleSave(item)"
                                                    [ngClass]="reviewCommentForm.invalid  || disabledControls ? 'btn-success button-width-icon-left mr-3 btn-success_disabled':'btn-success button-width-icon-left mr-3'"
                                                    [disabled]="reviewCommentForm.invalid  || disabledControls"></button>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-accordionTab>
                            </div>
                        </ng-template>
                    </p-accordionTab>
                </p-accordion>
            </div>
        </div>
    </form>
</div>